import {Component, Input, OnInit} from '@angular/core';
import {ProductImage} from "../../../common/interfaces/Product";

@Component({
  selector: 'products-carousel',
  templateUrl: './products-carousel.component.html',
  styleUrls: ['./products-carousel.component.scss'],
  // animations: fade
})
export class ProductsCarouselComponent implements OnInit {

  activeImage = ""
  @Input() images: ProductImage[]
  index = 0
  intervalId: number = 0

  ngOnInit(): void {
    // @ts-ignore
    this.intervalId = setInterval(() => {
      this.changeToNextImage()
    }, 2000)
    if (this.images.length === 1) {
      this.changeToNextImage()
    }
    this.activeImage = this.images[0].url
  }


  getColor(dotIndex: number): string {
    if (dotIndex === this.index) {
      return 'rgba(95, 179, 37, 1)'
    } else {
      return 'rgb(255,255,255)'
    }
  }

  moveImage(index: number) {
    clearInterval(this.intervalId)
    let newIndex = this.index + index
    if (newIndex === this.images.length) {
      this.index = 0
    } else if (newIndex < 0) {
      this.index = this.images.length - 1
    } else {
      this.index = newIndex
    }
    this.activeImage = this.images[this.index].url
  }

  showImage(i: number) {
    clearInterval(this.intervalId)
    this.index = i
    this.activeImage = this.images[i].url
  }

  changeToNextImage() {
    if (this.index === this.images.length - 1) {
      this.index = 0
    } else {
      this.index++
    }
    this.activeImage = this.images[this.index].url
  }

  setDefaultPlaceholder() {
    this.activeImage = "assets/product-placeholder.svg"
  }

}
